<script>
import Button from "@/components/Button";
import bus from "@/bus";
import router from "../../router";

export default {
    components: {
        Button,
    },
    methods: {
        async disconnected() {
            router.push("/signup-login")
            bus.emit("closeModal");
        },
    }
};
</script>

<template>
    <div class="p-8 z-50 bg-white shadow-xl rounded lg:min-w-xl lg:max-w-xl">
        <p class="mb-4">
            <span class="leading-snug">
                {{ $t("views.modals.logout.disconnected") }}
            </span>
        </p>
        <Button @click="disconnected">
            {{ $t("views.modals.logout.confirm") }}
        </Button>
    </div>
</template>
